import { createFileRoute } from "@tanstack/react-router";
import BlogRoiAiAgents from "@/pages/BlogRoiAiAgents";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/blog/roi-of-ai-agents-freight-forwarding")({
  head: () => pageHead("/blog/roi-of-ai-agents-freight-forwarding", "zh"),
  component: BlogRoiAiAgents,
});
